import { COOKIES } from "constants/cookies";
import { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { getCookie } from "services/cookies";

export const useCaptcha = () => {
  const captchaSiteKey =
    getCookie(COOKIES.RECAPTCHA_SITE_KEY) ||
    getCookie(COOKIES._GRECAPTCHA) ||
    process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);
  const hasRunCaptcha = useRef(false);

  useEffect(() => {
    if (captchaRef.current && !hasRunCaptcha.current) {
      hasRunCaptcha.current = true;
      captchaRef.current.execute();
    }
  }, [captchaRef]);

  const CaptchaComponent = captchaSiteKey && (
    <ReCAPTCHA
      ref={captchaRef}
      size="invisible"
      theme="light"
      sitekey={captchaSiteKey}
      onChange={setCaptchaToken}
      style={{ display: "inline-block" }}
    />
  );

  return { captchaToken, CaptchaComponent };
};
